import { useGlobalStore } from '../../stores/useGlobalStore';
import type { UpgradeSource } from '../../utils/constants/upgradeSources';

import { contact } from './endpoints';

import { makeAuthenticatedPostRequest } from './index';

export const logout = () => {
  useGlobalStore.getState().setUser(null);
};

export const sendUpgradeRequest = async (source: UpgradeSource) => {
  return await makeAuthenticatedPostRequest(contact, {
    message: 'Request for Upgrade',
    source,
  });
};
